<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>新建会员消费单</el-breadcrumb-item>
    </el-breadcrumb>

    <div>
      <el-card >
        <div style="display: flex;justify-content: center;align-items:center;width: 100%">
          <el-input v-model="customerRequest.queryText" placeholder="请输入会员手机号或者会员姓名，搜索会员" size="mini" style="width: 50%;"></el-input>
          <el-button size="mini" plain @click="queryCustomer">搜索一下</el-button>
        </div>
        <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;margin-top: 10px">
          <div>
            <span>会员姓名：</span>
            <el-input size="mini" type="primary" readonly v-model="hyOrder.customer.customerName" style="width: 50%;"></el-input>
          </div>
          <div>
            <span >消费人次：</span>
            <el-input v-model="hyOrder.peoples" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" style="width: 40%;"></el-input>
          </div>
          <div style="width: 30%;">
            <span >异地消费：</span>
            <el-radio-group v-model="hyOrder.isLocal">
              <el-radio :label="1">异地</el-radio>
              <el-radio :label="2">本地</el-radio>
            </el-radio-group>
          </div>
          <div>
            <el-checkbox v-model="hyOrder.isArrearage" @change="arrearageMethod">欠款单</el-checkbox>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>卡别信息：</span>
        <el-button size="mini" :disabled="hyOrder.customer == '' || hyOrder.customer.customerType > 2"
                   plain @click="showCustomerCardDialog">选择卡别</el-button>
      </div>
      <el-card>
        <div v-if="selectedCustomerCard != ''">
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 30%">卡别名称：</span>
              <el-input v-model="selectedCustomerCard.cardTypeName" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 30%">所属门店：</span>
              <el-input v-model="selectedCustomerCard.shopName" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
            <div style="width: 50%">
              <span style="width: 30%">会员等级：</span>
              <el-input v-model="selectedCustomerCard.cardLevelName" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 30%">适用项目：</span>
              <el-input v-model="selectedCustomerCard.useTypeName" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="selectedCustomerCard.cardType < 3">
            <div style="width: 50%">
              <span style="width: 30%">账户余额：</span>
              <el-input v-model="selectedCustomerCard.balance" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 30%">卡有效期：</span>
              <el-input v-model="selectedCustomerCard.validDate" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
          </div>
          <div v-if="selectedCustomerCard.cardType === 2">
            <div style="width: 50%" >
              <span style="width: 30%">赠送金额：</span>
              <el-input v-model="selectedCustomerCard.giveBalance" readonly size="mini" style="width: 80%;"></el-input>
            </div>
          </div>
          <div style="display: flex;justify-items: center; justify-content: space-between; width: 100%; margin-top: 10px;"
               v-if="selectedCustomerCard.cardType === 3">
            <div style="width: 50%">
              <span style="width: 30%">可用次数：</span>
              <el-input v-model="selectedCustomerCard.cardNum" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 30%">卡有效期：</span>
              <el-input v-model="selectedCustomerCard.validDate" readonly
                        size="mini" style="width: 80%;"></el-input>
            </div>
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>消费明细：</span>
        <el-button size="mini"  :disabled="addServiceDisable" plain @click="showHyConsumptionDialog">添加服务明细</el-button>
      </div>
      <el-card>
        <el-table :data="hySelectConsumptionList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            prop="userName"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteHyOrderSelectConsumptionList(scope.$index, hySelectConsumptionList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="consumptionName"
            label="项目名称" width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="dia"
            label="直径" width="160"
          >
            <template slot-scope="scope">
              <el-input :disabled="scope.row.isShowDia !== 1" v-model="scope.row.dia"
                        size="mini" @change="changeHyOrderZj" ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="数量/次数" width="160"
          >
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.num"
                               size="mini"  :precision="0"
                               @change="changeHyOrderZj" :min="1" :max="1000" ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" >
          </el-table-column>
          <el-table-column
            align="center"
            label="会员价格">
            <template slot-scope="scope">
              <div v-if="scope.row.type === 1">
                <div v-if="hyOrder.customer.customerType == 1">
<!--                  <div v-if="selectedCustomerCard  === ''">-->
<!--                    {{scope.row.price}}-->
<!--                  </div>-->
                  <div v-if="selectedCustomerCard.cardLevel === 0">
                    {{scope.row.price}}
                  </div>
                  <div v-if="selectedCustomerCard.cardLevel === 1">
                    {{scope.row.priceDiamond}}
                  </div>
                  <div v-if="selectedCustomerCard.cardLevel === 2">
                    {{scope.row.pricePlatinum}}
                  </div>
                  <div v-if="selectedCustomerCard.cardLevel === 3">
                    {{scope.row.priceGold}}
                  </div>
                  <div v-if="selectedCustomerCard.cardLevel === 4">
                    {{scope.row.priceBronze}}
                  </div>
                </div>
                <div v-if="hyOrder.customer.customerType > 1">
                  {{scope.row.price}}
                </div>
              </div>
              <div v-if="scope.row.type === 2">
                <div v-if="hyOrder.customer.customerType == 1">
<!--                  <div v-if="selectedCustomerCard  === ''">-->
<!--                    {{ scope.row.price.toFixed(2)}}-->
<!--                  </div>-->
                  <div v-if="selectedCustomerCard.cardLevel === 0">
                    {{ scope.row.price.toFixed(2)}}
                  </div>
                  <div v-if="selectedCustomerCard.cardLevel > 0">
                    {{ (scope.row.price * selectedCustomerCard.productDiscount / 100).toFixed(2)}}
                  </div>
                </div>
                <div v-if="hyOrder.customer.customerType > 1">
                  {{ scope.row.price.toFixed(2)}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="金额小计">
            <template slot-scope="scope">
              <div v-if="scope.row.isShowDia === 1">
                {{ (scope.row.price * scope.row.num * scope.row.dia).toFixed(2)}}
              </div>
              <div v-if="scope.row.isShowDia !== 1">
                <div v-if="scope.row.type === 1">
                  <div v-if="hyOrder.customer.customerType == 1">
<!--                    <div v-if="selectedCustomerCard === ''">-->
<!--                      {{(scope.row.price * scope.row.num).toFixed(2)}}-->
<!--                    </div>-->
                    <div v-if="selectedCustomerCard.cardLevel === 0">
                      {{(scope.row.price * scope.row.num).toFixed(2)}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 1">
                      {{ (scope.row.priceDiamond * scope.row.num).toFixed(2)}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 2">
                      {{ (scope.row.pricePlatinum * scope.row.num).toFixed(2)}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 3">
                      {{ (scope.row.priceGold * scope.row.num).toFixed(2)}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel === 4">
                      {{ (scope.row.priceBronze * scope.row.num).toFixed(2)}}
                    </div>
                  </div>
                  <div v-if="hyOrder.customer.customerType > 1">
                    {{(scope.row.price * scope.row.num).toFixed(2)}}
                  </div>
                </div>
                <div v-if="scope.row.type === 2">
                  <div v-if="hyOrder.customer.customerType == 1">
<!--                    <div v-if="selectedCustomerCard  === ''">-->
<!--                      {{ (scope.row.price * scope.row.num).toFixed(2)}}-->
<!--                    </div>-->
                    <div v-if="selectedCustomerCard.cardLevel === 0">
                      {{ (scope.row.price * scope.row.num).toFixed(2)}}
                    </div>
                    <div v-if="selectedCustomerCard.cardLevel > 0">
                      {{ (scope.row.price * selectedCustomerCard.productDiscount / 100 * scope.row.num).toFixed(2)}}
                    </div>
                  </div>
                  <div v-if="hyOrder.customer.customerType > 1">
                    {{(scope.row.price * scope.row.num).toFixed(2)}}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>服务人员：</span>
        <el-button size="mini"  :disabled="addServerDisable" plain @click="showServerDialog">添加服务人员</el-button>
      </div>
      <el-card>
        <el-table :data="selectServerList" fit border stripe="stripe" width="100%"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteServerShowList(scope.$index, selectServerList)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="服务人员">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机">
          </el-table-column>
          <el-table-column
            align="center"
            label="提成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rate" size="mini"
                        onkeyup="value=value.replace(/[^\d.]/g,'')"
                        @change="setHyOrderUserRate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="margin-top: 10px">
        <span>金额信息：</span>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >应收金额：</span>
            <el-input v-model="hyOrder.receivable" readonly  placeholder="请输入内容"  size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">会员优惠：</span>
            <el-input v-model="hyOrder.orderDiscounts" readonly  placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">抹零金额：</span>
            <el-input v-model="hyOrder.moLing"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      :disabled="isHyMoLingSet"  @change="setHyOrderMoLing"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;">凑整金额：</span>
            <el-input v-model="hyOrder.couZheng"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
                      :disabled="isHyCouZhengSet"
                      @change="setHyOrderCouZheng"  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
          <div v-if="hyOrder.isArrearage === true">
            <span style="width: 10%;margin-left: 5px;"> 欠款金额：</span>
            <el-input v-model="hyOrder.arrearageMoney" onkeyup="value=value.replace(/[^\d.]/g,'')"
                      placeholder="请输入内容" size="mini" style="width: 60%;"
                      @change="setArrearageMoney"
            />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 实收金额：</span>
            <el-input v-model="hyOrder.received" readonly  placeholder="请输入内容" size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
        <span>优惠券信息：</span>
        <span style="color: #8c939d; font-size: 12px">您有{{ticketCount}}张优惠券可用,每个消费单最多只能使用一张优惠券</span>
        <el-button size="mini"
                   :disabled="hySelectConsumptionList.length === 0 || selectedCustomerCard.cardType == 3"
                   @click="showCustomerTicketDialog">选择优惠券</el-button>
      </div>
      <el-card>
        <div style="display: flex;justify-content: space-between;align-items:center;width: 100%;margin-top: 10px;">
          <div>
            <span >优惠券类别：</span>
            <el-input v-model="selectedCustomerTicket.ticketTypeName" readonly size="mini" style="width: 60%;"/>
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 1 || selectedCustomerTicket.ticketType === 4 ||
                  selectedCustomerTicket.ticketType === 6" >
            <span style="width: 10%;margin-left: 5px;">面额：</span>
            <el-input v-model="selectedCustomerTicket.money" readonly  placeholder="请输入内容" size="mini" style="width: 60%;"/>
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 3">
            <span style="width: 10%;margin-left: 5px;">满额：</span>
            <el-input v-model="selectedCustomerTicket.fullMoney" readonly size="mini" style="width: 60%;" />
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 3">
            <span style="width: 10%;margin-left: 5px;">减额：</span>
            <el-input v-model="selectedCustomerTicket.subMoney" readonly size="mini" style="width: 60%;" />
          </div>
          <div v-if="selectedCustomerTicket.ticketType === 2 || selectedCustomerTicket.ticketType === 5">
            <span style="width: 10%;margin-left: 5px;"> 折扣率：</span>
            <el-input v-model="selectedCustomerTicket.rate" size="mini" style="width: 60%;" />
          </div>
          <div v-if="selectedCustomerTicket.ticketType > 3">
            <span style="width: 10%;margin-left: 5px;"> 产品和服务：</span>
            <el-input v-model="selectedCustomerTicket.consumptionName" readonly  size="mini" style="width: 60%;" />
          </div>
          <div>
            <span style="width: 10%;margin-left: 5px;"> 有效期：</span>
            <el-input v-model="selectedCustomerTicket.validDate" readonly  size="mini" style="width: 60%;" />
          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>支付方式：</span>
      </div>
      <el-card>
        <div style="width:100%;">
          <div v-for="(item, index) in orgPayTypeList" :key="index" style="display: inline-block; width: 25%;margin-top: 10px" >
            <span style="display: inline-block; width: 80px;text-align: right"> {{item.payCnName}}:</span>
            <el-input v-model="item.money"
                      placeholder="请输入内容" size="mini" style="width: 100px;margin-right: 10px;"
                      :readonly="item.payEnName === 'zengsonghuiyuan' || item.payEnName == 'douyintuangou'
                      || item.payEnName == 'meituantuangou' || item.payEnName == 'koubeituangou'
                      || item.payEnName == 'xiaochengxutuangou' || item.payEnName === 'huiyuan'
                      || item.payEnName == 'kuaishoutuangou' || item.payEnName == 'gaodetuangou'"
                      @change="resetHyOrderPay" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>

          </div>
        </div>
      </el-card>
      <div style="margin-top: 10px">
        <span>备注说明：</span>
      </div>
      <el-card>
        <el-input v-model="hyOrder.comment" type="textarea" placeholder="请输入内容" size="mini"/>
      </el-card>
    </div>

    <span class="dialog-footer">
        <el-button size="mini" @click="closeHyOrderDialog">取 消</el-button>
        <el-button size="mini" @click="createHyOrder">确 定</el-button>
    </span>

    <!-- 选择会员 -->
    <el-dialog
      title="会员列表"
      width="60%"
      :visible.sync="selectCustomerDialogVisible"
      :before-close="closeSelectCustomerDialog"
      show-close
      modal
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="customerList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="110">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="hyOrder.customer"  @change.native="selectCustomer(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerName"
          label="会员名称" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机" >
        </el-table-column>
        <el-table-column
          align="center"
          prop="registerOrgName"
          label="所属门店" >
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 显示服务和产品-->
    <el-drawer
      title="添加会员消费项目"
      size="60%"
      :visible.sync="hyConsumptionDrawer"
      :before-close="closeHyConsumptionDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <el-card>
              <el-tree
                :data="hyConsumptionTypeList"
                :props="consumptionTypeProps"
                @node-click="consumptionTypeHandleNodeClick"
                :highlight-current="true"
                node-key="id"
                :filter-node-method="consumptionTypeFilterNode"
                default-expand-all
                ref="serviceTree"
              >
              </el-tree>
            </el-card>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-card class="box-card">
            <el-table :data="hyConsumptionList" fit border stripe="stripe"
                      height="580px"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                label="操作" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.type === 1">
                    <!-- 储值会员 -->
                    <div v-if="hyOrder.customer.customerType === 1">
<!--                      <div v-if="selectedCustomerCard === ''">-->
<!--                        <el-input-number v-model="scope.row.num"-->
<!--                                         size="mini" :precision="0"-->
<!--                                         @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000"></el-input-number>-->
<!--                      </div>-->
<!--                      <div v-else>-->
<!--                        <el-input-number v-model="scope.row.num"-->
<!--                                         size="mini" :precision="0"-->
<!--                                         v-if="selectedCustomerCard.balance === 0 && scope.row.consumptionParentTypeName !== '次卡'"-->
<!--                                         @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000"></el-input-number>-->
<!--                        <el-input-number v-model="scope.row.num"-->
<!--                                         size="mini" :precision="0"-->
<!--                                         v-if="selectedCustomerCard.balance === 0 && scope.row.consumptionParentTypeName !== '次卡'"-->
<!--                                         @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000"></el-input-number>-->
                        <el-input-number v-model="scope.row.num"
                                         size="mini" :precision="0"
                                         v-if="selectedCustomerCard.balance > 0 && scope.row.consumptionParentTypeName !== '次卡'"
                                         :disabled="scope.row.consumptionTypeName ==='抖音团购' || scope.row.consumptionTypeName ==='美团团购' ||
                                          scope.row.consumptionTypeName ==='口碑团购' || scope.row.consumptionTypeName ==='小程序团购'
                                          || scope.row.consumptionTypeName ==='快手团购' || scope.row.consumptionTypeName ==='高德团购'"
                                         @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000" ></el-input-number>
                        <el-input-number v-model="scope.row.num"
                                         size="mini" :precision="0"
                                         v-if="selectedCustomerCard.balance > 0 && scope.row.consumptionParentTypeName === '次卡'"
                                         @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="ckCount" ></el-input-number>
                      </div>
<!--                    </div>-->
                      <!-- 非储值会员,康复会员 -->
                      <div v-if="hyOrder.customer.customerType > 1">
                        <el-input-number v-model="scope.row.num"
                                         size="mini" :precision="0"
                                         v-if="scope.row.consumptionParentTypeName !== '次卡'"
                                         @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000"></el-input-number>
                      </div>
                  </div>
                  <div v-if="scope.row.type === 2">
                    <div v-if="hyOrder.customer.customerType == 1">
                      <el-input-number v-model="scope.row.num"
                                       size="mini" :precision="0"
                                       v-if="selectedCustomerCard.balance > 0"
                                       @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000"></el-input-number>
                    </div>
                    <div v-if="hyOrder.customer.customerType > 1">
                      <el-input-number v-model="scope.row.num"
                                       size="mini" :precision="0"
                                       @change="hyOrderNumHandleChange(scope.row)" :min="0" :max="1000"></el-input-number>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="consumptionName"
                label="服务名称" >
              </el-table-column>
              <el-table-column
                align="center"
                prop="price"
                label="标准价格" >
              </el-table-column>
              <el-table-column
                align="center"
                label="会员价格">
                <template slot-scope="scope">
                  <div v-if="scope.row.type === 1">
                    <div v-if="hyOrder.customer.customerType === 1">
                      <div v-if="selectedCustomerCard === ''">
                        {{scope.row.price}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 0">
                        {{scope.row.price}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 1">
                        {{scope.row.priceDiamond}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 2">
                        {{scope.row.pricePlatinum}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 3">
                        {{scope.row.priceGold}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel === 4">
                        {{scope.row.priceBronze}}
                      </div>
                    </div>
                    <div v-if="hyOrder.customer.customerType > 1">
                      {{scope.row.price}}
                    </div>
                  </div>
                  <div v-if="scope.row.type === 2">
                    <div v-if="hyOrder.customer.customerType === 1">
                      <div v-if="selectedCustomerCard.cardLevel === 0">
                        {{scope.row.price}}
                      </div>
                      <div v-if="selectedCustomerCard.cardLevel > 0">
                        {{ (scope.row.price * (selectedCustomerCard.productDiscount/100)).toFixed(2)}}
                      </div>
                    </div>
                    <div v-if="hyOrder.customer.customerType > 1">
                      {{scope.row.price}}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </el-drawer>

    <!-- 次卡明细 -->
    <el-dialog
      title="卡别列表"
      :visible.sync="customerCardDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeCustomerCardDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="customerCardList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="selectCardIndex"
                      :disabled="scope.row.state === 2 || scope.row.state === 9"
                      @change.native="selectCustomerCard(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardTypeName"
          label="名称" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardLevel"
          :formatter="cardLevelFormatter"
          label="卡等级">
        </el-table-column>
        <el-table-column
          align="center"
          prop="balance"
          label="余额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="giveBalance"
          label="赠额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cardNum"
          label="次数">
        </el-table-column>
        <el-table-column
          align="center"
          prop="shopName"
          label="所属门店" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          :formatter="cardStateFormatter"
          label="状态">
        </el-table-column>
        <el-table-column
          align="center"
          prop="useTypeName"
          label="用途">
        </el-table-column>
        <el-table-column
          align="center"
          prop="validDate"
          label="有效期" width="150">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="cardSizeChange"
          @current-change="cardCurrentChange"
          :current-page="cardCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="cardPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="cardPageTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 优惠券明细 -->
    <el-dialog
      title="优惠券列表"
      :visible.sync="customerTicketDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeCustomerTicketDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="customerTicketList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="400px">
        <el-table-column
          align="center"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <el-radio :label="scope.$index" v-model="selectTicketIndex"
                      :disabled="scope.row.isUse === 2"
                      @change.native="selectCustomerTicket(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="优惠券名成"
          align="center" width="150">
        </el-table-column>
        <el-table-column
          prop="ticketTypeName"
          label="优惠券类型"
          align="center" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="money"
          label="面额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="fullMoney"
          label="满金额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="subMoney"
          label="减金额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="rate"
          label="折扣率" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="单品名称" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="validDate"
          label="有效期" width="150">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="ticketHandleSizeChange"
          @current-change="ticketHandleCurrentChange"
          :current-page="ticketCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="ticketPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="ticketPageTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 选择服务人员 -->
    <el-dialog
      title="服务人员列表"
      size="400px"
      :visible.sync="serverDialogVisible"
      :before-close="closeServerDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="serverList" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                @selection-change="serverSelectChange">
        <el-table-column
          align="center"
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="userName"
          label="服务人员姓名">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>


</template>

<script>
export default {
  data(){
    return{
      areaId: window.sessionStorage.getItem('areaId'),
      currentOrgId: window.sessionStorage.getItem('currentOrgId'),
      userId: window.sessionStorage.getItem("userId"),
      authorities: window.sessionStorage.getItem('authorities'),
      orgLevel: window.sessionStorage.getItem('orgLevel'),
      moLingRate: window.sessionStorage.getItem('moLingRate'),
      orgName: window.sessionStorage.getItem('orgName'),
      //是否提交，1是 2否，默认为未提交
      // orderIsSubmit: 2,
      reserveCustomerId:'',
      reserveId:'',
      reserveShopId:'',
      customerRequest:{
        orgId:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        customerId:'',
        shopId:''
      },
      hyOrder:{
        customer:{},     //会员信息
        orderOrgId:'',   //订单所属机构id
        orderOrgName:'', //订单所属机构名称
        receivable: '',   //应收金额
        orderDiscounts:'',//优惠金额
        received:'',     //实收金额
        consumptions:[], //消费项目
        balancePay:'',   //会员支付
        cashPay:'',      //现金支付
        weChatPay:'',    //微信支付
        aliPay:'',       //支付宝支付
        bankPay:'',      //银行卡支付
        lakalaPay:'',    //拉卡拉支付
        posPay:'',       //pos机支付
        miniWeChatPay:'',//微信小程序支付
        scanCodePay:'',  //扫码支付
        giveBalancePay:'',//赠送会员支付
        moLing:'',       //抹零金额
        couZheng:'',       //凑整金额
        productDiscount:'', //产品折扣
        servers:[],      //服务人员
        orderPayTypeList:[],//订单支付方式
        isLocal:2,       //是否本地消费
        creator:'',      //创建人
        modifier:'',      //更新人
        comment:'',        //备注
        peoples:'',
        isArrearage:false, //是否欠款
        isArr:'',         //欠款金额1
        arrearageMoney:'', //欠款金额
        customerCard:'',
        selectedTicket:'',
        reserveId:0,
        customerType:''
      },
      selectedCustomerCard:'',
      addServiceDisable:true,      //是否可以添加消费项目
      addServerDisable:true,       //是否可以添加消费项目
      hySelectConsumptionList:[],  //已选消费项目
      hyConsumptionTypeList:[],    //消费项目类别
      hyConsumptionList:[],        //消费项目列表
      consumptionTypeProps:{       //消费项目树展示信息
        label: 'consumptionTypeName',
        children: 'children'
      },
      selectServerList:[],
      isHyMoLingSet:false,
      isHyCouZhengSet:false,
      selectedCustomerTicket:'',
      orgPayTypeList:[],
      orderPayTypeList:[],
      orderPayTypeTotalMoney:[],
      selectCustomerDialogVisible:false,
      customerList:[],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      hyConsumptionDrawer:false,   //消费项目窗口是否显示
      customerCardDialogVisible:false,
      customerCardList:[],
      selectCardIndex:'',
      cardCurrentPage: 1,
      cardPageSize:20,
      cardPageTotal:0,
      customerTicketDialogVisible:false,
      customerTicketList:[],
      selectTicketIndex:'',
      ticketCurrentPage: 1,
      ticketPageSize:20,
      ticketPageTotal:0,
      ticketCount:0,
      cardText:[
        {cardLevel:0, name:'普通会员'},
        {cardLevel:1, name:'钻石会员'},
        {cardLevel:2, name:'铂金会员'},
        {cardLevel:3, name:'黄金会员'},
        {cardLevel:4, name:'大众会员'}
      ],
      cardStateText:[
        {state:1, name:'正常'},
        {state:2, name:'过期'},
        {state:9, name:'跨区域'},
      ],
      ckCount:0,
      dataType:'',
      consumptionTypeId:'',
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        consumptionId:''
      },
      serverList:[],
      serverDialogVisible:false,
      kuaishoutuangou:0,
      douyintuangou:0,
      meituantuangou:0,
      koubeituangou:0,
      xiaochengxutuangou:0,
      gaodetuangou:0,
      ciCardMoney: 0
    }
  },
  methods:{
    queryCustomer(){
      if (this.customerRequest.queryText === '' || this.customerRequest.queryText === null){
        return this.$message.warning("请输入会员手机号或会员姓名进行搜索！");
      }
      this.currentPage = 1;
      this.pageSize = 20;
      this.getCustomersCount();
      this.getCustomers();
      this.showCustomerListDialog();
    },
    async getCustomersCount(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      this.customerRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/query/customers/count`,this.customerRequest)
      this.pageTotal = res.totalPage;
    },
    async getCustomers(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      this.customerRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/query/customers`,this.customerRequest)
      this.customerList = res.data;
    },
    showCustomerListDialog(){
      this.customerList = [];
      this.pageTotal = 0;
      this.selectCustomerDialogVisible = true;
    },
    closeSelectCustomerDialog(){
      if (this.hySelectConsumptionList.length > 0){
        this.jsHyOrderAmount();
        this.setHyOrderPay();
      }
      this.hyOrder.moLing = 0;
      this.hyOrder.couZheng = 0;
      this.selectCustomerDialogVisible = false;
    },
    arrearageMethod(){
      if (this.hyOrder.isArrearage){
        this.hyOrder.isArr = 1;
      } else {
        this.hyOrder.isArr = 2;
        this.hyOrder.arrearageMoney = 0;
        this.jsHyOrderAmount();
        this.setHyOrderPay();
      }
    },
    showCustomerCardDialog(){
      this.selectCardIndex = '';
      this.loadCustomerCard();
      this.customerCardDialogVisible = true;
    },
    closeCustomerCardDialog(){
      this.customerCardDialogVisible = false;
    },
    async selectCustomerCard(data){
      this.selectedCustomerCard = data;
      this.ckCount = data.cardNum;
      if (data.cardLevel === 0){
        this.selectedCustomerCard.cardLevelName = '普通会员';
      }
      if (data.cardLevel === 1){
        this.selectedCustomerCard.cardLevelName = '钻石会员';
      }
      if (data.cardLevel === 2){
        this.selectedCustomerCard.cardLevelName = '铂金会员';
      }
      if (data.cardLevel === 3){
        this.selectedCustomerCard.cardLevelName = '黄金会员';
      }
      if (data.cardLevel === 4){
        this.selectedCustomerCard.cardLevelName = '大众会员';
      }
      await this.loadProductDiscount(data.shopId, data.cardLevel);

      if(data.balance > 0){
        let include = false;
        this.hySelectConsumptionList.map((item, index) =>{
          if (item.consumptionParentTypeName == '团购'){
            include = true;
          }
        })
        if(include){
          this.hySelectConsumptionList = [];
          this.hyOrder.moLing = 0;
          this.hyOrder.couZheng = 0;
          this.hyOrder.arrearageMoney =0;
          this.hyOrder.receivable =0;
          this.hyOrder.orderDiscounts =0;
          this.hyOrder.received =0;
          this.clearPay();
          this.$message.warning("您选择的卡片不能消费团购项目，请重新选择消费项目！");
        }
      } else {
        this.hySelectConsumptionList = [];
      }

      if(this.hySelectConsumptionList.length > 0){
        this.hyOrder.moLing = 0;
        this.hyOrder.couZheng = 0;
        this.hyOrder.arrearageMoney =0;
        this.jsHyOrderAmount();
        this.setHyOrderPay();
      }
      this.closeCustomerCardDialog();
    },
    clearPay(){
      this.orgPayTypeList.map((item)=>{
        item.money = 0;
      })
    },
    async loadProductDiscount(shopId, cardLevel){
      const {data:res} = await this.$http.get(`/org/discount/${shopId}/${cardLevel}`)
      this.selectedCustomerCard.productDiscount = res.data;
    },
    loadCustomerCard(){
      this.loadCustomerCardCount();
      this.loadCustomerCardList();
    },
    async loadCustomerCardCount(){
      const {data:res} = await this.$http.get(`/load/customerCard/count/${this.hyOrder.customer.id}`)
      this.cardPageTotal = res.totalPage;
    },
    async loadCustomerCardList(){
      const {data:res} = await this.$http.post(`/load/customerCard/list/${this.hyOrder.customer.id}`, {
        pageNum: this.cardCurrentPage,
        pageSize: this.cardPageSize
      })
      this.customerCardList = res.data;
      //资金监管区域
      let zjjgqy = [2,5,6,9,12,15,16,17,19,18,510]
      this.customerCardList.map((item) => {
        if(zjjgqy.includes(this.areaId - 0)){
          if(!zjjgqy.includes(item.areaId)){
            item.state = 9;
          }
        } else {
          //分公司的会员
          if (item.areaId == item.shopId){
            if(this.orgLevel == 2){
              if(item.areaId != this.currentOrgId){
                item.state = 9;
              }
            }
            if (this.orgLevel == 3){
              if(item.areaId != this.areaId){
                item.state = 9;
              }
            }
          }
          if (item.areaId != item.shopId){
            if(this.orgLevel == 2){
              if(item.areaId != this.currentOrgId){
                item.state = 9;
              }
            }
            if (this.orgLevel == 3){
              if(item.areaId != this.areaId){
                item.state = 9;
              }
            }
          }
        }
      })
    },
    cardSizeChange(val) {
      this.cardPageSize = val;
      this.loadCustomerCardList();
    },
    cardCurrentChange(val) {
      this.cardCurrentPage = val;
      this.loadCustomerCardList();
    },
    cardLevelFormatter(row){
      let value = "";
      for (let i = 0; i < this.cardText.length; i++){
        let item = this.cardText[i];
        if (row.cardLevel === item.cardLevel) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    cardStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.cardStateText.length; i++){
        let item = this.cardStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async showHyConsumptionDialog(){
      this.hyConsumptionDrawer = true;
      this.hyConsumptionList = [];
      const {data:res} = await this.$http.get(`/consumptionType/orgId/${this.currentOrgId}`)
      this.hyConsumptionTypeList = res.data;
    },
    deleteHyOrderSelectConsumptionList(index,rows){
      rows.splice(index, 1);
      this.hyOrder.moLing = 0;
      this.hyOrder.couZheng=0;
      this.isHyMoLingSet=false;
      this.isHyCouZhengSet=false;
      this.selectedCustomerTicket = '';
      //消费项目发生了变化，重新计算订单金额
      this.jsHyOrderAmount();
      this.setHyOrderPay();
    },
    //创建订单
    async createHyOrder(){
      if (this.hyOrder.peoples < 1){
        this.$message.warning("请填写消费人次！")
        return;
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      //选择的是次卡支付
      if (this.selectedCustomerCard.cardType == 3){
        let include = true;
        this.hySelectConsumptionList.map((item)=>{
          if (item.id == this.selectedCustomerCard.consumptionId){
            include = false;
          }
        })

        if (include){
          this.$message.warning("选择的是次卡，消费明细未包含次卡消费项目，请仔细检查！");
          this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
          return;
        }
      }

      // let totalMoney = 0;
      // this.orgPayTypeList.map((item) => {
      //   if (item.payEnName !== 'zengsonghuiyuan'){
      //     totalMoney += item.money - 0;
      //   }
      // })
      // let hj = (this.hyOrder.arrearageMoney - 0) + (this.hyOrder.received - 0);
      // let yj = (this.hyOrder.receivable-0) - (this.hyOrder.orderDiscounts-0) - (this.hyOrder.moLing - 0) - (this.hyOrder.giveBalancePay - 0) + (this.hyOrder.couZheng);
      // if (this.hyOrder.isArrearage === true && this.hyOrder.arrearageMoney > 0){
      //   if (hj.toFixed(2) != yj){
      //     this.$message.warning("支付金额 与 实收金额+欠款金额的和 不一致，请仔细检查");
      //     this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      //     return;
      //   }
      // } else {
      //   if ((this.hyOrder.received -0 ).toFixed(2) !== totalMoney.toFixed(2)){
      //     this.$message.warning("支付金额与实收金额不一致，请仔细检查");
      //     this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      //     return;
      //   }
      // }

      let result = false;
      this.hySelectConsumptionList.map((item) => {
        if (item.isShowDia === 1 && (item.dia === undefined || item.dia === 0)){
          result = true;
        }
      })
      if(result){
        this.$message.warning("请填写直径毫米数");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return ;
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.hyOrder.orderOrgId = this.currentOrgId;
      this.hyOrder.consumptions = this.hySelectConsumptionList;
      this.hyOrder.orderPayTypeList = this.orgPayTypeList;
      this.hyOrder.servers = this.selectServerList;
      this.hyOrder.orderOrgName = this.orgName;
      this.hyOrder.orderReceivable = this.hyOrder.receivable;
      this.hyOrder.orderReceived = this.hyOrder.received;
      if(this.selectedCustomerCard !== ''){
        this.hyOrder.customerCard = this.selectedCustomerCard;
      } else {
        this.hyOrder.customerCard = null;
      }

      if(this.selectedCustomerTicket !== ''){
        this.hyOrder.selectedTicket = this.selectedCustomerTicket;
      } else {
        this.hyOrder.selectedTicket = null;
      }

      this.hyOrder.reserveId = this.reserveId;
      this.hyOrder.customerType = this.hyOrder.customer.customerType;
      this.hyOrder.creator = this.userId;
      // this.orderIsSubmit = 1;
      const {data:res} = await this.$http.post(`/order/hyOrder`,this.hyOrder);
      if (res.code === 200){
        this.$message.success("操作成功！");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        // this.orderIsSubmit = 2;
        await this.$router.push('/orders')
      } else {
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        this.$message.warning(res.msg);
      }
    },
    changeHyOrderZj(){
      this.selectedCustomerTicket = '';
      this.jsHyOrderAmount();
      this.setHyOrderPay();
      this.hyOrder.moLing=0;
      this.hyOrder.couZheng=0;
      this.isHyMoLingSet=false;
      this.isHyCouZhengSet=false;
    },
    showServerDialog(){
      this.loadServer();
      this.serverDialogVisible = true;
    },
    async loadServer(){
      const {data:res} = await this.$http.get(`/users/valida/${2}/orgId/${this.currentOrgId}/pageNum/1/pageSize/99`)
      this.serverList = res.data.list;
    },
    closeServerDialog(){
      this.resetHyOrderUserRate();
      this.serverDialogVisible = false;
    },
    resetHyOrderUserRate(){
      let rateTotal = 0;
      if (this.selectServerList.length > 0){
        this.selectServerList.map((item, index) => {
          if (index === this.selectServerList.length -1){
            let rate = 100 - rateTotal;
            item.rate = rate.toFixed(2)
          } else {
            item.rate = (100 / this.selectServerList.length).toFixed(2);
            rateTotal += item.rate - 0;
          }
        })
      }
    },
    setHyOrderUserRate(){
      let rateTotal = 0;
      this.selectServerList.map((item, index) =>{
        if (index === this.selectServerList.length-1){
          let rate = 100 - rateTotal;
          if (rate <= 0){
            item.rate = 0;
          } else {
            item.rate = rate.toFixed(2);
          }
        } else {
          rateTotal += item.rate - 0;
        }
      })
    },
    serverSelectChange(val){
      this.selectServerList = val;
    },
    deleteServerShowList(index,rows){
      rows.splice(index, 1);
      this.resetHyOrderUserRate();
    },
    setHyOrderMoLing(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsHyOrderAmount();
      let maxMoLingMoney = (this.hyOrder.receivable * this.moLingRate / 100).toFixed(2);
      let hyOrderMoLing = this.hyOrder.moLing - 0;
      let giveBalancePay = this.hyOrder.giveBalancePay - 0;
      let couzheng = this.hyOrder.couZheng - 0;
      if (hyOrderMoLing > (maxMoLingMoney - 0)){
        this.$message.warning("抹零金额不能超过应收金额的" + this.moLingRate + "%");
        this.hyOrder.moLing = 0;
        return;
      }
      this.isHyCouZhengSet = true;
      this.hyOrder.received = (this.hyOrder.receivable - this.hyOrder.orderDiscounts - hyOrderMoLing - giveBalancePay + couzheng).toFixed(2);
      this.setHyOrderPay();

      this.hyOrder.arrearageMoney = '';
      this.selectedCustomerTicket = '';
    },
    setHyOrderCouZheng(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsHyOrderAmount();
      let hyOrderMoLing = this.hyOrder.moLing - 0;
      let giveBalancePay = this.hyOrder.giveBalancePay - 0;
      let couZheng = this.hyOrder.couZheng - 0;
      this.isHyMoLingSet = true;
      this.hyOrder.received = (this.hyOrder.receivable - this.hyOrder.orderDiscounts - hyOrderMoLing - giveBalancePay + couZheng).toFixed(2);
      this.setHyOrderPay();

      this.hyOrder.arrearageMoney = '';
      this.selectedCustomerTicket = '';
    },
    setArrearageMoney(){
      //每次设置抹零，都需要重新计算一下订单金额
      this.jsHyOrderAmount();
      let money = 0;
      this.hySelectConsumptionList.map((item) => {
        if (item.consumptionTypeName === '抖音团购' || item.consumptionTypeName === '美团团购'
          || item.consumptionTypeName === '口碑团购' || item.consumptionTypeName === '小程序团购'
          || item.consumptionTypeName === '快手团购' || item.consumptionTypeName === '高德团购') {
          money += item.price * item.num;
        }
      })
      if (this.hyOrder.arrearageMoney === ''){
        this.hyOrder.received = ((this.hyOrder.receivable - 0) -  (this.hyOrder.orderDiscounts - 0) - (this.hyOrder.giveBalancePay - 0)
          - (this.hyOrder.moLing - 0) + (this.hyOrder.couZheng - 0) - (this.hyOrder.arrearageMoney - 0)).toFixed(2);
        this.qiankuan = 0;
      } else {
        if (this.hyOrder.arrearageMoney > (this.hyOrder.received - money)){
          this.$message.warning("欠款金额不能大于" + (this.hyOrder.received - money).toFixed(2));
          this.hyOrder.arrearageMoney = '';
          return;
        }
        this.qiankuan = parseFloat(this.hyOrder.arrearageMoney);
        this.hyOrder.received = ((this.hyOrder.receivable - 0) -  (this.hyOrder.orderDiscounts - 0) - (this.hyOrder.giveBalancePay - 0)
          - (this.hyOrder.moLing - 0) + (this.hyOrder.couZheng - 0) - (this.hyOrder.arrearageMoney - 0)).toFixed(2);
      }

      this.setHyOrderPay();
    },
    showCustomerTicketDialog(){
      this.selectTicketIndex = '';
      this.loadCustomerTicket();
      this.customerTicketDialogVisible = true;
    },
    closeCustomerTicketDialog(){
      this.customerTicketDialogVisible = false;
    },
    loadCustomerTicket(){
      this.customerRequest.pageNum = this.ticketCurrentPage;
      this.customerRequest.pageSize = this.ticketPageSize;
      this.customerRequest.shopId = this.currentOrgId;
      this.loadCustomerTicketCount();
      this.loadCustomerTicketList();
    },
    async loadCustomerKyTicketCount(){
      const {data:res} = await this.$http.post(`/load/customer/ticket/count`, this.customerRequest)
      this.ticketCount = res.totalPage;
    },
    async loadCustomerTicketCount(){
      const {data:res} = await this.$http.post(`/load/customer/ticket/count`, this.customerRequest)
      this.ticketPageTotal = res.totalPage;
    },
    async loadCustomerTicketList(){
      const {data:res} = await this.$http.post(`/load/customer/ticket/list`, this.customerRequest)
      this.customerTicketList = res.data;

      this.customerTicketList.map((item) => {
        if (item.state === 1){
          if (item.ticketType < 3){
            item.isUse = 1; //是否可用  1是  2否
          }
          if (item.ticketType === 3){
            if (this.hyOrder.received >= item.fullMoney){
              item.isUse = 1; //是否可用  1是  2否
            } else {
              item.isUse = 2;
            }
          }
          if (item.ticketType > 3){
            let result = false;
            this.hySelectConsumptionList.map((consumptionItem) => {
              if (item.consumptionName === consumptionItem.consumptionName){
                result = true;
              }
            })
            if (result){
              item.isUse = 1;
            } else {
              item.isUse = 2;
            }
          }
        } else {
          item.isUse = 2;
        }
      });
    },
    ticketHandleSizeChange(val) {
      this.ticketPageSize = val;
      this.loadCustomerTicketList();
    },
    ticketHandleCurrentChange(val) {
      this.ticketCurrentPage = val;
      this.loadCustomerTicketList();
    },
    selectCustomerTicket(row){
      this.selectedCustomerTicket = row;
      this.closeCustomerTicketDialog();
      this.resetHyOrder();
    },
    resetHyOrder(){
      //初始化一下金额
      this.hyOrder.received = ((this.hyOrder.receivable - 0) -  (this.hyOrder.orderDiscounts - 0)
        - (this.hyOrder.moLing - 0) + (this.hyOrder.couZheng - 0) - (this.hyOrder.arrearageMoney - 0)).toFixed(2);
      //全场优惠券
      if (this.selectedCustomerTicket.ticketType === 1){
        this.hyOrder.received = ((this.hyOrder.receivable - 0) -  (this.hyOrder.orderDiscounts - 0)
          - (this.hyOrder.moLing - 0) + (this.hyOrder.couZheng - 0) - (this.hyOrder.arrearageMoney - 0)
          - (this.selectedCustomerTicket.money - 0)).toFixed(2);
      }
      //全场折扣券
      if (this.selectedCustomerTicket.ticketType === 2){
        this.hyOrder.received = (this.hyOrder.received * this.selectedCustomerTicket.rate / 10).toFixed(2);
      }
      //全场满减券
      if (this.selectedCustomerTicket.ticketType === 3){
        this.hyOrder.received = (this.hyOrder.received - this.selectedCustomerTicket.subMoney).toFixed(2);
      }
      //单品优惠券
      if (this.selectedCustomerTicket.ticketType === 4){
        this.hyOrder.received = (this.hyOrder.received - this.selectedCustomerTicket.money).toFixed(2);
      }
      //单品折扣券
      if (this.selectedCustomerTicket.ticketType === 5){
        let dpHj = 0;
        if (this.selectedCustomerCard.cardLevel > 0){
          this.hySelectConsumptionList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              if (consumptionItem.isShowDia !== 1){
                //表示为服务
                if (consumptionItem.type ===1){
                  if (this.selectedCustomerCard.cardLevel === 1){
                    dpHj += consumptionItem.priceDiamond * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 2){
                    dpHj += consumptionItem.pricePlatinum * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 3){
                    dpHj += consumptionItem.priceGold * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 4){
                    dpHj += consumptionItem.priceBronze * consumptionItem.num;
                  }
                }
                //表示为产品
                if (consumptionItem.type === 2){
                  dpHj += consumptionItem.price * (this.selectedCustomerCard.productDiscount / 100) * consumptionItem.num;
                }
              }
            }
          })
        } else {
          this.hySelectConsumptionList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              if (consumptionItem.isShowDia === 1){   //是否显示直径
                if (consumptionItem.dia !== undefined){
                  dpHj += consumptionItem.price * consumptionItem.num * consumptionItem.dia;
                }
              } else {
                dpHj += consumptionItem.price * consumptionItem.num;
              }
            }
          })
        }
        let subHj = dpHj - (dpHj * this.selectedCustomerTicket.rate / 10);
        this.hyOrder.received = (this.hyOrder.received - subHj).toFixed(2);
      }
      //单品特价券
      if (this.selectedCustomerTicket.ticketType === 6){
        let dpHj = 0;
        let num = 0;
        if (this.selectedCustomerCard.cardLevel > 0){
          this.hySelectConsumptionList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              num = consumptionItem.num;
              if (consumptionItem.isShowDia !== 1){
                //表示为服务
                if (consumptionItem.type ===1){
                  if (this.selectedCustomerCard.cardLevel === 1){
                    dpHj += consumptionItem.priceDiamond * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 2){
                    dpHj += consumptionItem.pricePlatinum * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 3){
                    dpHj += consumptionItem.priceGold * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 4){
                    dpHj += consumptionItem.priceBronze * consumptionItem.num;
                  }
                }
                //表示为产品
                if (consumptionItem.type === 2){
                  dpHj += consumptionItem.price * (this.selectedCustomerCard.productDiscount / 100) * consumptionItem.num;
                }
              }
            }
          })
        } else {
          this.hySelectConsumptionList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              num = consumptionItem.num;
              dpHj += consumptionItem.price * consumptionItem.num;
            }
          })
        }
        let dpTj = this.selectedCustomerTicket.money * num;
        let subHj = dpHj - dpTj;
        this.hyOrder.received = (this.hyOrder.received - subHj).toFixed(2);
      }
      //单品兑换券
      if (this.selectedCustomerTicket.ticketType === 7){
        let dpHj = 0;
        let dpMoney = 0;
        if (this.selectedCustomerCard.cardLevel > 0){
          this.hySelectConsumptionList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              if (consumptionItem.isShowDia !== 1){
                //表示为服务
                if (consumptionItem.type ===1){
                  if (this.selectedCustomerCard.cardLevel === 1){
                    dpMoney = consumptionItem.priceDiamond;
                    dpHj += consumptionItem.priceDiamond * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 2){
                    dpMoney = consumptionItem.pricePlatinum;
                    dpHj += consumptionItem.pricePlatinum * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 3){
                    dpMoney = consumptionItem.priceGold;
                    dpHj += consumptionItem.priceGold * consumptionItem.num;
                  }
                  if (this.selectedCustomerCard.cardLevel === 4){
                    dpMoney = consumptionItem.priceBronze;
                    dpHj += consumptionItem.priceBronze * consumptionItem.num;
                  }
                }
                //表示为产品
                if (consumptionItem.type === 2){
                  dpMoney = consumptionItem.price;
                  dpHj += consumptionItem.price * (this.selectedCustomerCard.productDiscount / 100) * consumptionItem.num;
                }
              }
            }
          })
        } else {
          this.hySelectConsumptionList.map((consumptionItem) => {
            if (this.selectedCustomerTicket.consumptionName === consumptionItem.consumptionName){
              dpMoney = consumptionItem.price;
              dpHj += consumptionItem.price * consumptionItem.num;
            }
          })
        }
        this.hyOrder.received = (this.hyOrder.received - dpMoney).toFixed(2);
      }
      this.resetHyOrderPay();
    },
    resetHyOrderPay(){
      this.$nextTick(() => {
        //定义一个临时的支付方式数组，记录下都输入了哪些支付方式
        let tempPayType = [];
        this.orgPayTypeList.map((item) => {
          if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan' &&
            item.payEnName !== 'meituantuangou' && item.payEnName !== 'douyintuangou' &&
            item.payEnName !== 'xiaochengxutuangou' && item.payEnName !== 'koubeituangou'
            && item.payEnName !== 'kuaishoutuangou' && item.payEnName !== 'gaodetuangou'
          ) {
            if (item.money > 0) {
              let payType = {
                payEnName: item.payEnName,
                money: item.money - 0
              }
              tempPayType.push(payType);
            }
          }
        })

        //清空除团购和赠送之外所有的支付方式
        this.orgPayTypeList.map((item) => {
          if (item.payEnName !== 'zengsonghuiyuan' &&
            item.payEnName !== 'meituantuangou' && item.payEnName !== 'douyintuangou' &&
            item.payEnName !== 'xiaochengxutuangou' && item.payEnName !== 'koubeituangou'
            && item.payEnName !== 'kuaishoutuangou' && item.payEnName !== 'gaodetuangou'
          ) {
            item.money = ''
          }
        })

        let totalMoney = this.hyOrder.received - 0;
        if (this.hyOrder.customer.customerType == 1) {
          if (this.selectedCustomerCard.cardType === 3) {
            this.orgPayTypeList.map((item) => {
              if (item.payEnName === 'huiyuan') {
                item.money = this.ciCardMoney;
              }
            })
            let ckMoney = 0;
            let xianjin = (this.hyOrder.received - this.ciCardMoney).toFixed(2);
            this.orgPayTypeList.map((item) => {
              tempPayType.map((tempItem) => {
                if (item.payEnName === tempItem.payEnName && item.payEnName !== 'xianjin') {
                  if ((xianjin - ckMoney) < tempItem.money) {
                    item.money = xianjin - ckMoney
                  }
                  if ((xianjin - ckMoney) === tempItem.money) {
                    item.money = xianjin - ckMoney
                  }
                  if ((xianjin - ckMoney) > tempItem.money) {
                    item.money = tempItem.money
                  }
                  ckMoney += tempItem.money - 0
                }
              })
            })
            this.orgPayTypeList.map((item) => {
              if (item.payEnName === 'xianjin') {
                if (xianjin - ckMoney <= 0) {
                  item.money = 0;
                } else {
                  item.money = xianjin - ckMoney;
                }
              }
            })
          } else {
            let money = 0;
            if (this.selectedCustomerCard.balance > 0) {
              // this.orgPayTypeList.map((item) => {
              //   if (item.payEnName === 'huiyuan') {
              //     if ((totalMoney - money) <= this.selectedCustomerCard.balance) {
              //       if (totalMoney - money < 0) {
              //         item.money = 0;
              //       } else {
              //         item.money = (totalMoney - money).toFixed(2);
              //         money += item.money;
              //       }
              //     }
              //     if ((totalMoney - money) > this.selectedCustomerCard.balance) {
              //       item.money = this.selectedCustomerCard.balance;
              //       money += item.money;
              //     }
              //   }
              // })
              let tempMoney = totalMoney - money;
              let inputXian = 0;
              this.orgPayTypeList.map((item) => {
                tempPayType.map((tempItem) => {
                  if (item.payEnName === tempItem.payEnName && item.payEnName !== 'xianjin'
                    && item.payEnName !== 'huiyuan') {
                    if (tempMoney < tempItem.money) {
                      item.money = parseFloat(tempMoney.toFixed(2))
                    }
                    if (tempMoney === tempItem.money) {
                      item.money = parseFloat(tempMoney.toFixed(2))
                    }
                    if (tempMoney > tempItem.money) {
                      item.money = parseFloat(tempItem.money.toFixed(2))
                    }
                    money += item.money
                    tempMoney = totalMoney - money;
                  }
                  if(tempItem.payEnName == 'xianjin'){
                    inputXian = tempItem.money;
                  }
                })
              })

              let otherTotal = 0;
              this.orgPayTypeList.map((item) => {
                if (item.money > 0 && item.payEnName !== 'huiyuan') {
                  otherTotal += item.money - 0;
                }
              })

              if(otherTotal + inputXian == totalMoney){
                this.orgPayTypeList.map((item) => {
                  if (item.payEnName === 'xianjin') {
                    item.money = parseFloat(inputXian.toFixed(2))
                  }
                })
              } else {
                let huiyuan = totalMoney - money;
                this.orgPayTypeList.map((item) => {
                  if (item.payEnName === 'huiyuan') {
                    if (huiyuan <= this.selectedCustomerCard.balance) {
                      if (huiyuan <= 0) {
                        item.money = 0;
                      } else {
                        item.money = parseFloat(huiyuan.toFixed(2));
                        money += item.money;
                      }
                    }
                    if (huiyuan > this.selectedCustomerCard.balance) {
                      item.money = this.selectedCustomerCard.balance;
                      money += item.money;
                    }
                  }
                })


                if(inputXian == totalMoney - otherTotal){
                  this.orgPayTypeList.map((item) => {
                    if (item.payEnName === 'huiyuan'){
                      item.money = 0;
                    }
                    if (item.payEnName === 'xianjin') {
                      if (inputXian > 0) {
                        item.money = parseFloat(inputXian.toFixed(2))
                      } else {
                        item.money = 0;
                      }
                    }
                  })
                } else {
                  let xianjin = totalMoney - money;
                  this.orgPayTypeList.map((item) => {
                    if (item.payEnName === 'xianjin') {
                      if (xianjin > 0) {
                        item.money = parseFloat(xianjin.toFixed(2))
                      } else {
                        item.money = 0;
                      }
                    }
                  })
                }
              }
            }
          }
        } else {
          let meituan = 0;
          let douyin = 0;
          let kuaishou = 0;
          let gaode = 0;
          let koubei = 0;
          let xiaochengxu = 0;
          this.orgPayTypeList.map((item) => {
            if (item.payEnName == 'meituantuangou'){
              meituan = item.money;
            }
            if (item.payEnName == 'douyintuangou'){
              douyin = item.money;
            }
            if (item.payEnName == 'xiaochengxutuangou'){
              xiaochengxu = item.money;
            }
            if (item.payEnName == 'koubeituangou'){
              koubei = item.money;
            }
            if (item.payEnName == 'kuaishoutuangou'){
              kuaishou = item.money;
            }
            if (item.payEnName == 'gaodetuangou'){
              gaode = item.money;
            }
          })

          let fcMoney = 0;
          //可支配金额
          let kzpMoney = parseFloat((this.hyOrder.received - meituan - douyin - koubei - kuaishou - xiaochengxu - gaode).toFixed(2));
          this.orgPayTypeList.map((item) => {
            tempPayType.map((tempItem) => {
              if (item.payEnName === tempItem.payEnName && item.payEnName !== 'xianjin') {
                if ((kzpMoney - fcMoney) < tempItem.money) {
                  item.money = parseFloat((kzpMoney - fcMoney).toFixed(2));
                }
                if ((kzpMoney - fcMoney) === tempItem.money) {
                  item.money = tempItem.money
                }
                if ((kzpMoney - fcMoney) > tempItem.money) {
                  item.money = tempItem.money
                }
                fcMoney += item.money;
              }
            })
          })
          let xian = kzpMoney - fcMoney;
          this.orgPayTypeList.map((item) => {
            if (item.payEnName === 'xianjin') {
              if (xian > 0) {
                item.money = parseFloat(xian.toFixed(2))
              } else {
                item.money = ''
              }
            }
          })
        }
      })
      // let totalMoney = this.hyOrder.received;
      // let money = 0;
      // //储值会员的计算方式
      // if (this.hyOrder.customer.customerType == 1){
      //   // if(this.selectedCustomerCard === ''){
      //   //   this.orgPayTypeList.map((item) => {
      //   //     if (item.payEnName !== 'xianjin' && item.payEnName !== 'zengsonghuiyuan'){
      //   //       if (item.money > (this.hyOrder.received - money)){
      //   //         item.money = (this.hyOrder.received - money).toFixed(2);
      //   //       }
      //   //       money += item.money - 0;
      //   //     }
      //   //   })
      //   //   this.orgPayTypeList.map((item) => {
      //   //     if (item.payEnName === 'xianjin'){
      //   //       if ((totalMoney - money) < 0){
      //   //         item.money = 0;
      //   //       } else {
      //   //         item.money = (totalMoney - money).toFixed(2);
      //   //       }
      //   //     }
      //   //   })
      //   // } else {
      //     //判断卡类别，如果是次卡，则只需要
      //     if (this.selectedCustomerCard.cardType === 3){
      //       let xianjin = (this.hyOrder.received - this.ciCardMoney).toFixed(2);
      //       this.orgPayTypeList.map((item) =>{
      //         if (item.payEnName === 'huiyuan'){
      //           item.money = this.ciCardMoney;
      //         }
      //       })
      //       this.orgPayTypeList.map((item) => {
      //         if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan'
      //           && item.payEnName !== 'xianjin'){
      //           if (item.money > (xianjin-money)){
      //             item.money = (xianjin-money).toFixed(2);
      //           }
      //           money += item.money - 0;
      //         }
      //       })
      //       this.orgPayTypeList.map((item) => {
      //         if (item.payEnName === 'xianjin' ){
      //           if (xianjin-money <= 0){
      //             item.money = 0;
      //           } else {
      //             item.money = xianjin-money;
      //           }
      //         }
      //       })
      //     } else {
      //       // if (this.selectedCustomerCard.balance === 0){
      //       //   this.orgPayTypeList.map((item) => {
      //       //     if (item.payEnName !== 'xianjin' && item.payEnName !== 'zengsonghuiyuan'){
      //       //       if (item.money > (this.hyOrder.received - money)){
      //       //         item.money = (this.hyOrder.received - money).toFixed(2);
      //       //       }
      //       //       money += item.money - 0;
      //       //     }
      //       //   })
      //       //   this.orgPayTypeList.map((item) => {
      //       //     if (item.payEnName === 'xianjin'){
      //       //       if ((totalMoney - money) < 0){
      //       //         item.money = 0;
      //       //       } else {
      //       //         item.money = (totalMoney - money).toFixed(2);
      //       //       }
      //       //     }
      //       //   })
      //       // }
      //       if (this.selectedCustomerCard.balance > 0){
      //         this.orgPayTypeList.map((item) => {
      //           if (item.payEnName !== 'huiyuan' && item.payEnName !== 'zengsonghuiyuan'){
      //             money += item.money - 0;
      //           }
      //         })
      //         this.orgPayTypeList.map((item) => {
      //           if (item.payEnName === 'huiyuan'){
      //             if ((totalMoney - money) <= this.selectedCustomerCard.balance){
      //               if (totalMoney - money < 0){
      //                 item.money = 0;
      //               } else {
      //                 item.money = (totalMoney - money).toFixed(2);
      //               }
      //             }
      //             if ((totalMoney - money) > this.selectedCustomerCard.balance){
      //               item.money = this.selectedCustomerCard.balance;
      //             }
      //           }
      //         })
      //       }
      //     }
      //   // }
      // } else {
      //   this.orgPayTypeList.map((item) => {
      //     if (item.payEnName !== 'xianjin' && item.money > 0){
      //       if (item.money > (this.hyOrder.received - money)){
      //         item.money = (this.hyOrder.received - money).toFixed(2);
      //       }
      //       money += item.money - 0;
      //     }
      //   })
      //   this.orgPayTypeList.map((item) => {
      //     if (item.payEnName === 'xianjin'){
      //       if ((this.hyOrder.received - money) < 0){
      //         item.money = 0;
      //       } else {
      //         item.money = (this.hyOrder.received - money).toFixed(2);
      //       }
      //     }
      //   })
      // }
    },
    closeHyOrderDialog(){
      this.$router.go(-1);
    },
    async selectCustomer(data){
      if(this.hyOrder.customer.id != data.id){
        this.selectedCustomerCard = ''
      }
      const {data:res} = await this.$http.get(`/customer/customerId/${data.id}/orgId/${this.currentOrgId}`)
      this.hyOrder.customer = res.data;
      if (this.hyOrder.customer.id > 0){
        this.addServiceDisable = false;
        this.addServerDisable = false;
        this.customerRequest.customerId = this.hyOrder.customer.id;
      }
      // this.selectedCustomerCard = '';
      await this.loadCustomerKyTicketCount();
      this.closeSelectCustomerDialog();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCustomers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCustomers();
    },
    clearTuanGou(){
      this.kuaishoutuangou = 0;
      this.douyintuangou = 0;
      this.meituantuangou = 0;
      this.xiaochengxutuangou = 0;
      this.koubeituangou = 0;
    },
    jsHyOrderAmount(){
      this.clearTuanGou();
      //储值会员
      if (this.hyOrder.customer.customerType == 1){
        // if (this.selectedCustomerCard === ''){
        //   this.hyOrderNoLevelAmount();
        // } else {
        if (this.selectedCustomerCard.cardLevel > 0){
          this.hyOrderAmount();     //计算会员订单金额
          if(this.selectedCustomerCard.cardType == 2){
            this.hyOrderGiveBalancePay();
          }
        } else {
          this.hyOrderNoLevelAmount();
          if(this.selectedCustomerCard.cardType == 2){
            this.hyOrderGiveBalancePay();
          }
        }
      // }
      } else {
        this.hyOrderNoLevelAmount();
      }
      // this.setHyOrderPay();
    },
    //计算订单金额
    hyOrderAmount(){
      let receivable = 0; //应收金额
      let received = 0;   //实收金额
      this.douyintuangou=0;
      this.kuaishoutuangou=0;
      this.meituantuangou=0;
      this.koubeituangou=0;
      this.xiaochengxutuangou=0;
      this.gaodetuangou=0;
      let result = true;  //是否可以设置抹零，如果消费项目全部为团购项目，则不可以设置抹零
      this.hySelectConsumptionList.map((item) => {
        if (item.consumptionTypeName !== '抖音团购' && item.consumptionTypeName !== '美团团购'
          && item.consumptionTypeName !== '口碑团购' && item.consumptionTypeName !== '小程序团购'
          && item.consumptionTypeName !== '活动修脚' && item.consumptionTypeName !== '快手团购'
          && item.consumptionTypeName !== '高德团购'){
          result = false;
        }
        if (item.isShowDia === 1){   //是否包含直径类消费项目
          if (item.dia !== undefined){
            receivable += item.price * item.num * item.dia;
            received += item.price * item.num * item.dia;
          }
        }
        if (item.isShowDia !== 1){
          //表示为服务
          if (item.type ===1){
            receivable += item.price * item.num;
            if (item.consumptionTypeName === '快手团购'){
              this.kuaishoutuangou += item.price * item.num
            }
            if (item.consumptionTypeName === '抖音团购'){
              this.douyintuangou += item.price * item.num
            }
            if (item.consumptionTypeName === '美团团购'){
              this.meituantuangou += item.price * item.num
            }
            if (item.consumptionTypeName === '口碑团购'){
              this.koubeituangou += item.price * item.num
            }
            if (item.consumptionTypeName === '小程序团购'){
              this.xiaochengxutuangou += item.price * item.num
            }
            if (item.consumptionTypeName === '高德团购'){
              this.gaodetuangou += item.price * item.num
            }
            if (this.selectedCustomerCard.cardLevel === 0){
              received += item.price * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 1){
              received += item.priceDiamond * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 2){
              received += item.pricePlatinum * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 3){
              received += item.priceGold * item.num;
            }
            if (this.selectedCustomerCard.cardLevel === 4){
              received += item.priceBronze * item.num;
            }
          }
          //表示为产品
          if (item.type === 2){
            receivable += item.price * item.num;
            received += item.price * (this.selectedCustomerCard.productDiscount / 100) * item.num;
          }
        }
      })
      this.isHyMoLingSet = result;
      this.hyOrder.receivable = receivable.toFixed(2);  //应收金额
      this.hyOrder.received = received.toFixed(2);      //实收金额
      this.hyOrder.orderDiscounts = (receivable - received).toFixed(2); //优惠金额
    },
    setHyOrderPay(){
      //先将设置过的全部情况
      this.orgPayTypeList.map((item) =>{
        item.money = '';
      })
      //储值会员的计算方式
      if (this.hyOrder.customer.customerType == 1){
        //表示没有可用的会员卡
        // if(this.selectedCustomerCard === ''){
        //   //计算出需要会员余额支付的部分
        //   let balance1 = (this.hyOrder.received - this.kuaishoutuangou - this.meituantuangou - this.douyintuangou - this.koubeituangou - this.xiaochengxutuangou).toFixed(2);
        //   //需要会员余额支付的部分-会员余额，表示需要其他支付方式支付。默认为现金
        //   // let xianjin1 = (balance1 - this.selectedCustomerCard.balance).toFixed(2);
        //   this.orgPayTypeList.map((item) =>{
        //     if (item.payEnName === 'xianjin'){
        //       if (balance1 < 0){
        //         item.money = 0;
        //       } else {
        //         item.money = balance1;
        //       }
        //     }
        //     if (item.payEnName === 'kuaishoutuangou'){
        //       item.money = this.kuaishoutuangou.toFixed(2);
        //     }
        //     if (item.payEnName === 'meituantuangou'){
        //       item.money = this.meituantuangou.toFixed(2);
        //     }
        //     if (item.payEnName === 'douyintuangou'){
        //       item.money = this.douyintuangou.toFixed(2);
        //     }
        //     if (item.payEnName === 'koubeituangou'){
        //       item.money = this.koubeituangou.toFixed(2);
        //     }
        //     if (item.payEnName === 'xiaochengxutuangou'){
        //       item.money = this.xiaochengxutuangou.toFixed(2);
        //     }
        //   })
        // } else {
          //判断卡类别，如果是次卡，则只需要
          if (this.selectedCustomerCard.cardType === 3){
            let xianjin = (this.hyOrder.received - this.ciCardMoney).toFixed(2);
            this.orgPayTypeList.map((item) =>{
              if (item.payEnName === 'huiyuan'){
                item.money = this.ciCardMoney;
              }
              if(item.payEnName === 'xianjin'){
                item.money = xianjin;
              }
            })
          } else {
            //计算出需要会员余额支付的部分
            let balance = (this.hyOrder.received - this.kuaishoutuangou - this.meituantuangou - this.douyintuangou - this.koubeituangou - this.xiaochengxutuangou - this.gaodetuangou).toFixed(2);
            //需要会员余额支付的部分-会员余额，表示需要其他支付方式支付。默认为现金
            let xianjin = (balance - this.selectedCustomerCard.balance).toFixed(2);
            if (this.selectedCustomerCard.balance > 0){
              this.orgPayTypeList.map((item) =>{
                if (item.payEnName === 'huiyuan'){
                  if(balance >= this.selectedCustomerCard.balance){
                    item.money = this.selectedCustomerCard.balance;
                  }
                  if(balance < 0){
                    item.money = 0;
                  }
                  if (balance < this.selectedCustomerCard.balance && balance > 0) {
                    item.money = balance;
                  }
                }
                if(item.payEnName === 'xianjin'){
                  if (xianjin > 0) {
                    item.money = xianjin;
                  }
                }
                if (item.payEnName === 'zengsonghuiyuan'){
                  item.money = this.hyOrder.giveBalancePay;
                }
              })
            }
            // if (this.selectedCustomerCard.balance === 0){
            //   this.orgPayTypeList.map((item) =>{
            //     if (item.payEnName === 'xianjin'){
            //       if (balance < 0){
            //         item.money = 0;
            //       } else {
            //         item.money = balance;
            //       }
            //     }
            //     if (item.payEnName === 'kuaishoutuangou'){
            //       item.money = this.kuaishoutuangou.toFixed(2);
            //     }
            //     if (item.payEnName === 'meituantuangou'){
            //       item.money = this.meituantuangou.toFixed(2);
            //     }
            //     if (item.payEnName === 'douyintuangou'){
            //       item.money = this.douyintuangou.toFixed(2);
            //     }
            //     if (item.payEnName === 'koubeituangou'){
            //       item.money = this.koubeituangou.toFixed(2);
            //     }
            //     if (item.payEnName === 'xiaochengxutuangou'){
            //       item.money = this.xiaochengxutuangou.toFixed(2);
            //     }
            //   })
            // }
          }
        // }
      } else {
        let needPay = (this.hyOrder.received - this.kuaishoutuangou - this.meituantuangou - this.douyintuangou - this.koubeituangou - this.xiaochengxutuangou - this.gaodetuangou).toFixed(2);
        this.orgPayTypeList.map((item) => {
          if (item.payEnName === 'xianjin') {
            if (needPay < 0) {
              item.money = 0;
            } else {
              item.money = needPay;
            }
          }
          if (item.payEnName === 'kuaishoutuangou') {
            item.money = this.kuaishoutuangou.toFixed(2);
          }
          if (item.payEnName === 'meituantuangou') {
            item.money = this.meituantuangou.toFixed(2);
          }
          if (item.payEnName === 'douyintuangou') {
            item.money = this.douyintuangou.toFixed(2);
          }
          if (item.payEnName === 'koubeituangou') {
            item.money = this.koubeituangou.toFixed(2);
          }
          if (item.payEnName === 'xiaochengxutuangou') {
            item.money = this.xiaochengxutuangou.toFixed(2);
          }
          if (item.payEnName === 'gaodetuangou') {
            item.money = this.gaodetuangou.toFixed(2);
          }
        })
      }
    },
    hyOrderNoLevelAmount(){
      let receivable = 0; //应收金额
      this.kuaishoutuangou=0;
      this.douyintuangou=0;
      this.meituantuangou=0;
      this.koubeituangou=0;
      this.xiaochengxutuangou=0;
      this.gaodetuangou=0;
      this.ciCardMoney = 0;
      let result = true;
      this.hySelectConsumptionList.map((item) =>{
        if (item.consumptionTypeName !== '抖音团购' && item.consumptionTypeName !== '美团团购'
          && item.consumptionTypeName !== '口碑团购' && item.consumptionTypeName !== '小程序团购'
          && item.consumptionTypeName !== '活动修脚' && item.consumptionTypeName !== '快手团购'
          && item.consumptionTypeName !== '高德团购'){
          result = false;
        }
        if (item.consumptionParentTypeName === '次卡'){
          this.ciCardMoney = item.price * item.num;
        }
        if (item.isShowDia === 1){   //是否显示直径
          if (item.dia !== undefined){
            receivable += item.price * item.num * item.dia;
          }
        } else {
          if (item.consumptionTypeName === '快手团购'){
            this.kuaishoutuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '抖音团购'){
            this.douyintuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '美团团购'){
            this.meituantuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '口碑团购'){
            this.koubeituangou += item.price * item.num
          }
          if (item.consumptionTypeName === '小程序团购'){
            this.xiaochengxutuangou += item.price * item.num
          }
          if (item.consumptionTypeName === '高德团购'){
            this.gaodetuangou += item.price * item.num
          }
          receivable += item.price * item.num;
        }
      })
      this.isHyMoLingSet = result;
      this.hyOrder.receivable = receivable.toFixed(2);
      this.hyOrder.received = receivable.toFixed(2);
      this.hyOrder.orderDiscounts = 0;
    },
    hyOrderGiveBalancePay(){
      if (this.selectedCustomerCard.giveBalance > 0){
        let giveRate = (this.selectedCustomerCard.giveBalance / this.selectedCustomerCard.balance).toFixed(2);
        let giveMoney = (this.hyOrder.received * giveRate).toFixed(2);
        if (giveMoney > this.selectedCustomerCard.giveBalance){
          this.hyOrder.giveBalancePay = this.selectedCustomerCard.giveBalance
        } else {
          this.hyOrder.giveBalancePay = giveMoney;
        }
      } else {
        this.hyOrder.giveBalancePay = 0;
      }

      //计算完成后，需要重新计算订单的实际支付金额
      this.hyOrder.received = (this.hyOrder.received - this.hyOrder.giveBalancePay).toFixed(2);
    },
    closeHyConsumptionDialog(){
      this.jsHyOrderAmount();
      this.setHyOrderPay();
      this.selectedCustomerTicket = '';
      this.hyConsumptionDrawer = false;
    },
    async consumptionTypeHandleNodeClick(data){
      this.dataType = data.type;
      if (data.consumptionTypeName === '服务分类'){
        this.dataType = 1;
      }
      if (data.consumptionTypeName === '产品分类'){
        this.dataType = 2;
      }
      this.consumptionTypeId = data.consumptionTypeId;
      if (data.consumptionParentTypeName === '次卡'){
        await this.loadCkConsumption();
      } else {
        await this.loadConsumption();
      }
    },
    async loadCkConsumption(){
      this.consumptionRequest.dateType = this.dataType;
      this.consumptionRequest.consumptionId = this.selectedCustomerCard.consumptionId;
      this.consumptionRequest.orgId = this.currentOrgId
      const {data:res} = await this.$http.post(`/load/ck/consumption`, this.consumptionRequest)
      this.hyConsumptionList = res.data;
    },
    loadConsumption(){
      this.consumptionRequest.dateType = this.dataType;
      this.consumptionRequest.typeId = this.consumptionTypeId;
      this.consumptionRequest.orgId = this.currentOrgId
      this.consumptionRequest.pageNum = 1;
      this.consumptionRequest.pageSize = 1000;
      this.loadConsumptionList();
    },
    async loadConsumptionCount(){
      const {data:res} = await this.$http.post(`/load/count/consumption`, this.consumptionRequest)
      this.pageTotal4 = res.totalPage;
    },
    async loadConsumptionList(){
      const {data:res} = await this.$http.post(`/load/list/consumption`, this.consumptionRequest)
      this.hyConsumptionList = res.data;
    },
    consumptionTypeFilterNode(value, data) {
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    hyOrderNumHandleChange(value){
      let result = true;
      for (let i = 0; i < this.hySelectConsumptionList.length; i++) {
        if (this.hySelectConsumptionList[i].id === value.id && value.num > 0){
          this.hySelectConsumptionList[i].num = value.num;
          result = false;
        }

        if (this.hySelectConsumptionList[i].id === value.id && value.num === 0){
          this.hySelectConsumptionList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.hySelectConsumptionList.push(value);
      }
    },
    async reserveOpenHyOrderDialog(customerId,reserveShopId){                  //会员消费单
      const {data:res} = await this.$http.get(`/customer/customerId/${customerId}/orgId/${reserveShopId}`)
      this.hyOrder.customer = res.data;
      if (this.hyOrder.customer.id > 0){
        this.addServiceDisable = false;
        this.addServerDisable = false;
        this.customerRequest.customerId = this.hyOrder.customer.id;
      }
      await this.loadCustomerKyTicketCount();
    },
    async loadOrgPayType(){
      const {data:res} = await this.$http.get(`/payType/orgPayType/orgId/${this.currentOrgId}`)
      this.orgPayTypeList = res.data;
    },

    async loadOrderPayTypeTotalMoney(){
      const {data:res} = await this.$http.get(`/order/payTypeTotal/orgId/${this.currentOrgId}`)
      this.orderPayTypeTotalMoney = res.data;
    },
  },
  created(){
    let reserveCustomerId = this.$route.query.customerId;
    let reserveId = this.$route.query.reserveId;
    let reserveShopId = this.$route.query.reserveShopId;
    if (reserveCustomerId > 0 && reserveShopId > 0){
      this.reserveOpenHyOrderDialog(reserveCustomerId, reserveShopId);
    }
    this.loadOrgPayType();
    this.loadOrderPayTypeTotalMoney();
  }
}
</script>

<style scoped lang="less">
.container {
  height: 1500px;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/newMemberOrder.vue